import { Helmet } from 'react-helmet-async';
// sections
import SsoCallbackView from 'src/sections/auth/microsoft/sso-callback-view';

// ----------------------------------------------------------------------

export default function SsoCallbackPage() {
  return (
    <>
      <Helmet>
        <title>SSO Sign-in | {window.REACT_APP_TITLE || 'Webwork'}</title>
      </Helmet>

      <SsoCallbackView />
    </>
  );
}
